import { History } from 'lucide-react';
import { useWorkspaceStore } from '@/stores/workspace-store';
import { useRecentTabStore } from '../recent-tab-store';
import type { SearchItem, SearchProvider } from '../types';
import type { WorkareaTab } from '@/types';

function label(t: WorkareaTab): string {
  if (t.type === 'table' || t.type === 'structure') return `${t.schema}.${t.table}`;
  if (t.type === 'query') return t.title || 'Query';
  if (t.type === 'info') return t.objectName;
  if (t.type === 'tunnel') return t.tunnelName;
  return t.id;
}

function relativeTime(ms: number): string {
  const diff = Math.floor((Date.now() - ms) / 1000);
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
}

/**
 * Tabs the user closed earlier in this session. Picking one reopens it
 * with all its state intact (where clauses, column config, SQL text, etc.)
 * since we stored the full WorkareaTab shape.
 */
export const recentTabSearchProvider: SearchProvider = {
  id: 'recent-tabs',
  kind: 'recent-tab',
  list: () => {
    const entries = useRecentTabStore.getState().entries;
    return entries.map<SearchItem>((e) => ({
      id: `recent:${e.tab.id}:${e.closedAt}`,
      kind: 'recent-tab',
      label: label(e.tab),
      subtitle: `Closed ${relativeTime(e.closedAt)} · ${e.tab.type}`,
      icon: History,
      boost: 0.7,
      action: () => useWorkspaceStore.getState().openTab(e.tab),
    }));
  },
};
